import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ToastConfig {
  isVisible: boolean;
  message: string;
  bgColor?: string;
  borderColor?: string;
  iconSrc?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppToastService {
  private toastSubject = new BehaviorSubject<ToastConfig>({
    isVisible: false,
    message: '',
    bgColor: 'bg-[#FFFBFA]',
    borderColor: 'border-[#FDA29B]',
    iconSrc: 'assets/icons/alert.svg'
  });
  
  toast$ = this.toastSubject.asObservable();

  showToast(config: Partial<ToastConfig>) {
    this.toastSubject.next({
      ...this.toastSubject.value,
      ...config,
      isVisible: true
    });

    // Auto hide after 5 seconds
    setTimeout(() => {
      this.hideToast();
    }, 5000);
  }

  hideToast() {
    this.toastSubject.next({
      ...this.toastSubject.value,
      isVisible: false
    });
  }
}